import axios from "axios"
import dayjs from 'dayjs'
import numeral from "numeral"
import string from "../utilities/string"
import productGallery from "./productGallery"
import modal from "./modal"
import Swiper, { Thumbs, Navigation, Pagination, Zoom, EffectFade } from "swiper/core"

Swiper.use([Thumbs, Navigation, Pagination, Zoom, EffectFade])

const productBuyBox = {
  currentOptions: null,
  currentVariant: null,
  product: null,
  productHandle: '',

  addToCart(event) {
    event.preventDefault()
    const atcButton = document.getElementById('atcButton')
    const atcButtonSticky = document.getElementById('atcButtonSticky')
    const productForm = document.getElementById('productForm')
    const quantity = productForm.querySelector('input[name=quantity]')

    if (atcButton.dataset.loading) return

    if (this.currentVariant) {
      const add = atcButton.querySelector('[data-add]')
      const adding = atcButton.querySelector('[data-adding]')
      const added = atcButton.querySelector('[data-added]')
      const btnPrice = atcButton.querySelector('[data-btn-price]')

      const addToSticky = atcButtonSticky.querySelector('[data-add]')
      const addingToSticky = atcButtonSticky.querySelector('[data-adding]')
      const addedToSticky = atcButtonSticky.querySelector('[data-added]')
      const stickyBtnPrice = atcButtonSticky.querySelector('[data-btn-price-sticky]')

      const mainQuantity = quantity ? quantity.value : 1
      let properties = {}

      let domProps = productForm.querySelectorAll('[name^="properties"]')
      domProps.forEach(el => {
        properties[el.name.replace('properties', '').replace('[', '').replace(']', '')] = el.value
      })

      let mainProduct = {
        id: this.currentVariant.id,
        quantity: mainQuantity,
        properties: properties
      };

      let addItemsArray = [];

      var bundleData = window.newBundleData[this.currentVariant.id];
      if (bundleData['bundleVariantIDS']) {
        var bundleItemPrices = bundleData['bundleItemPrices'].split(',')
        var bundleIDS = bundleData['bundleVariantIDS'].split(',')
        var bundleQtys = bundleData['bundleVariantQtys'].split(',')
        var bundleMaxQuantity = bundleData['bundleMaxQuantity']

        var bundleID = this.product.handle + ':' + this.currentVariant.id
        var bundleTitle = this.product.title
        var bundleImage = this.product.featured_image
        var bundleURL = this.product.url

        for (let i = 0; i < bundleIDS.length; i++) {
          let quantity = parseInt(bundleQtys[i]) * mainQuantity
          let bundleData = {
            id: bundleIDS[i],
            quantity: quantity,
            properties: {
              Bundle: bundleTitle,
              _BundleImage: bundleImage,
              _BundleURL: bundleURL,
              _Amount: bundleQtys[i],
              _BundleIds: bundleID,
              _BundlePrice: bundleItemPrices[i],
              _BundleMaxQty: bundleMaxQuantity,
            }
          }
          addItemsArray.push(bundleData)
        }

        window.newBundleData[this.currentVariant.id]["bundleMaxQuantity"] -= mainQuantity;
        this.updateFormStatus();
      } else {
        addItemsArray.push(mainProduct);
      }

      // Enable Loading state.
      atcButton.dataset.loading = true
      add.classList.add('hidden')
      adding.classList.remove('hidden')
      if (btnPrice) {
        btnPrice.classList.remove('md:inline')
      }

      atcButtonSticky.dataset.loading = true
      addToSticky.classList.add('hidden')
      addingToSticky.classList.remove('hidden')
      if (stickyBtnPrice) {
        stickyBtnPrice.classList.remove('md:inline')
      }
      axios.post('/cart/add.js', {
        items: addItemsArray
      }).then(() => {
        // Enable Loaded state. Remove after 3 seconds.
        atcButton.classList.add('button-success')
        adding.classList.add('hidden')
        added.classList.remove('hidden')

        atcButtonSticky.classList.add('button-success')
        addingToSticky.classList.add('hidden')
        addedToSticky.classList.remove('hidden')

        const event = new Event('cartUpdated')
        window.dispatchEvent(event);

        setTimeout(() => {
          delete atcButton.dataset.loading
          atcButton.classList.remove('button-success')
          added.classList.add('hidden')
          add.classList.remove('hidden')

          delete atcButtonSticky.dataset.loading
          atcButtonSticky.classList.remove('button-success')
          addedToSticky.classList.add('hidden')
          addToSticky.classList.remove('hidden')

          if (window.innerWidth >= 768) {
            if (btnPrice) {
              btnPrice.classList.add('md:inline')
            }
            if (stickyBtnPrice) {
              stickyBtnPrice.classList.add('md:inline')
            }
          }
        }, 3000)
      }).catch(error => {
        console.log(error)
      })
    }
  },

  disableAtc(boolean, text, hideBIS) {
    const atcButton = document.getElementById('atcButton')
    const atcButtonSticky = document.getElementById('atcButtonSticky')
    const atcButtonText = document.getElementById('atcButtonText')
    const atcButtonStickyText = document.getElementById('atcButtonStickyText')

    if (!atcButton) return  // fully out of stock product

    if (!atcButton.classList.contains('unavailable-btn')) {
      atcButton.disabled = boolean
      atcButton.classList.add('fade-in')
      atcButtonText.innerText = text
      atcButtonText.classList.add('fade-in')

      atcButtonSticky.disabled = boolean
      atcButtonSticky.classList.add('fade-in')
      atcButtonStickyText.innerText = text
      atcButtonStickyText.classList.add('fade-in')

      if (boolean && !hideBIS) {
        document.getElementById('BIS_trigger').classList.remove('hidden')
      } else {
        document.getElementById('BIS_trigger').classList.add('hidden')
      }
      if (atcButtonSticky.disabled == true) {
        atcButtonSticky.classList.add('invisible')
      } else {
        atcButtonSticky.classList.remove('invisible')
      }
    }
  },

  initOutOfStock() {
    const allOptions = document.querySelectorAll('.option, .option-swatch')

    if (this.product.handle !== 'gift-card') {
      allOptions.forEach(option => {
        let value = option.dataset.value
        let variants = this.product.variants.filter(variant => {
          let handleizedOptions = variant.options.map(option => string.handleize(option))
          return handleizedOptions.includes(value)
        })

        if (!variants.length) {
          option.disabled = true
        }
      })
    }
  },

  selectOption(option, value, selectedVariant) {
    const optionIndex = this.product.options.findIndex(key => key === option)
    // Get all option DOM elements
    const allOptions = document.querySelectorAll(`[data-option='${string.handleize(option)}']`)
    const optionToSelect = document.querySelector(`[data-value='${string.handleize(value)}']`)
    const curentSelectText = document.getElementById(`current-${string.handleize(option)}`)

    // Remove all active option classes first
    allOptions.forEach(option => {
      option.classList.remove('active')
    })

    if (optionIndex === 0) {
      // Find first available variant.
      const variants = this.product.variants.filter(variant => {
        return variant.options.includes(value)
      })

      // Check other options to see if available, If not disable.
      Object.keys(this.currentOptions).forEach(key => {
        const keyIndex = this.product.options.findIndex(optionKey => optionKey === key)
        if (keyIndex !== 0) {
          // Set currentOptions to match found variant.

          let newValue = this.currentOptions[key];
          if (!selectedVariant) {
            newValue = variants[0].options[keyIndex]
            this.currentOptions[key] = newValue
          }

          let options = document.querySelectorAll(`[data-option='${string.handleize(key)}']`)

          // Remove previously active options
          options.forEach(option => {
            option.classList.remove('active')
          })

          // Set options as active.
          document.querySelector(`[data-value='${string.handleize(newValue)}']`).classList.add('active')
          document.getElementById(`current-${string.handleize(key)}`).innerText = newValue

          options.forEach(option => {
            let currentValue = option.dataset.value
            let variants = this.product.variants.filter(variant => {
              return variant.options.includes(value)
            })

            let handelizedOptions = []

            variants.forEach(variant => {
              variant.options.forEach(option => handelizedOptions.push(string.handleize(option)))
            })

            if (!handelizedOptions.includes(currentValue)) {
              option.disabled = true
              option.classList.add('unavailable')
            } else {
              option.disabled = false
              option.classList.remove('unavailable')
            }
          })
        }
      })
    } else if (optionIndex === 1) {
      const optionKeys = Object.keys(this.currentOptions)
      if (optionKeys.length === 2) return

      const variants = this.product.variants.filter(variant => {
        return variant.options.includes(value) && variant.options.includes(Object.values(this.currentOptions)[0])
      })

      let variant = variants.find(variant => {
        return variant.options.includes(Object.values(this.currentOptions)[2])
      })

      variant = variant ? variant : variants[0]

      // Check other options to see if available, If not disable.
      const key = optionKeys[2]
      const keyIndex = this.product.options.findIndex(optionKey => optionKey === key)
      if (keyIndex === 2) {
        // Set currentOptions to match found variant.
        const newValue = variant.options[keyIndex]
        this.currentOptions[key] = newValue
        let options = document.querySelectorAll(`[data-option='${string.handleize(key)}']`)

        // Remove previously active options
        options.forEach(option => {
          option.classList.remove('active')
        })

        // Set options as active.
        document.querySelector(`[data-value='${string.handleize(newValue)}']`).classList.add('active')
        document.getElementById(`current-${string.handleize(key)}`).innerText = newValue

        options.forEach(option => {
          let currentValue = option.dataset.value
          let variants = this.product.variants.filter(variant => {
            return variant.options.includes(value)
          })

          let handelizedOptions = []

          variants.forEach(variant => {
            variant.options.forEach(option => handelizedOptions.push(string.handleize(option)))
          })

          if (!handelizedOptions.includes(currentValue)) {
            option.disabled = true
          } else {
            option.disabled = false
          }
        })
      }
    }

    // Set selected option in product data
    this.currentOptions[option] = value

    // Set current variant ID with selected options
    this.setCurrentVariant(selectedVariant)

    if (optionToSelect) {
      optionToSelect.classList.add('active')
    }

    if (curentSelectText) {
      curentSelectText.innerText = value
    }
  },

  setCurrentVariant(variant) {
    if (variant) {
      this.currentVariant = variant;
    } else {
      let currentVariant = this.product.variants.filter((variant) => {
        return Object.keys(this.currentOptions).every((key) => {
          return variant.options.includes(this.currentOptions[key]);
        });
      });
      this.currentVariant = currentVariant[0];
    }

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("variant", this.currentVariant.id);
    window.history.replaceState(
      { variantId: this.currentVariant.id },
      "",
      "?" + urlParams.toString()
    );

    this.toggleBundleItems();

    // Update gallery
    productGallery.filterMedia(this.currentVariant.sku);

    // check if the new variant is on sale, if it is, update price, if not update price with no sale treatment
    const comparePrice = document.getElementById("comparePrice");
    const price = document.getElementById("price");
    const pricePromo = document.getElementById("pricePromo");

    if (pricePromo) {
      pricePromo.innerText = this.currentVariant.metafields.promo
        ? this.currentVariant.metafields.promo
        : "";
    }

    if (price && comparePrice) {
      const priceValue = price.querySelector("[data-price]");
      const compareValue = comparePrice.querySelector("[data-price]");
      const btnPrice = atcButton.querySelector('[data-btn-price]');
      const stickyBtnPrice = atcButtonSticky.querySelector('[data-btn-price-sticky]');

      if (this.currentVariant.price < this.currentVariant.compare_at_price) {
        compareValue.innerText = numeral(
          this.currentVariant.compare_at_price / 100
        ).format("$0,0.00");
        comparePrice.classList.remove("hidden");

        priceValue.innerText = numeral(this.currentVariant.price / 100).format(
          "$0,0.00"
        );
        price.classList.add("text-red");
      } else {
        comparePrice.classList.add("hidden");

        priceValue.innerText = numeral(this.currentVariant.price / 100).format(
          "$0,0.00"
        );
        price.classList.remove("text-red");
      }
      if (btnPrice) {
        btnPrice.innerText = numeral(this.currentVariant.price / 100).format("$0,0.00");
      }
      if (stickyBtnPrice) {
        stickyBtnPrice.innerText = numeral(this.currentVariant.price / 100).format("$0,0.00");
      }
    }

    // Remove quantity selector if product is digital (doesn't require shipping).

    this.updateFormStatus();
    this.updatePriceSavings();
    if (window.location.href.indexOf("churchsource") > -1 && typeof window.newBundleData !== 'undefined') {
      this.toggleBulkInfo();
    };
    // Set Digital Type
    const shippingMessage = document.getElementById("productShippingMessage");
    const digitalMessage = document.getElementById("productDigitalMessage");
    const digitalMessageType = document.getElementById("productDigitalType");

    if (shippingMessage || digitalMessage) {
      if (this.currentVariant.metafields.digital) {
        shippingMessage.classList.add("hidden");
        digitalMessage.classList.remove("hidden");
        digitalMessageType.innerText = this.currentVariant.metafields.digital;
      } else {
        digitalMessage.classList.add("hidden");
        shippingMessage.classList.remove("hidden");
      }
    }

    // Set description
    const descriptionLongContainer = document.querySelector(".meta-description-long");
    const descriptionShortContainer = document.querySelector(".meta-description-short");
    const descriptionLongContent = document.querySelector("[data-product-desc-long]");
    const descriptionShortContent = document.querySelector("[data-product-desc-short]");
    const detailsToggler = document.querySelector("[data-product-desc-short-toggler]");
    const sent_limit = 3;
    function initDetailsToggler(description) {
      String.prototype.truncateBySent = function(sentCount = 2, moreText = "") {
        //match ".","!","?" - english ending sentence punctuation
        var sentences = this.match(/[^\.!\?]+[\.!\?]+/g);
        if (sentences) {
          if (sentences.length >= sentCount && sentences.length > sentCount) {
            return sentences.slice(0, sentCount).join(" ") + moreText;
          }
        }
        return this;
      };
      if (description.split(".").length > sent_limit) {
        var descriptionShort = description.truncateBySent(sent_limit);
        var descriptionLong = description;
        descriptionShortContent.innerHTML = descriptionShort;
        descriptionLongContent.innerHTML = descriptionLong;
      } else {
        var descriptionLong = description;
        descriptionShortContent.innerHTML = descriptionLong;
        detailsToggler.classList.add("hidden");
      }
    }
    var element = document.getElementById("meta-description");

    document
      .querySelector("[data-product-desc-long-toggler]")
      .addEventListener("click", (event) => {
        descriptionShortContainer.classList.remove("hidden");
        descriptionLongContainer.classList.add("hidden");

      });
    document
      .querySelector("[data-product-desc-short-toggler]")
      .addEventListener("click", (event) => {
        descriptionLongContainer.classList.remove("hidden");
        descriptionShortContainer.classList.add("hidden");

      });
    if (this.currentVariant.metafields.variant_description) {
      var variantDescription = this.currentVariant.metafields.variant_description;
      initDetailsToggler(variantDescription);
    } else {
      initDetailsToggler();
    }

    // Set meta additional info
    const contributorVal = document.querySelector(".meta-contributor");
    const narratorsVal = document.querySelector(".meta-narrators");
    const contributorBioVal = document.querySelector(".meta-contributor-bio");
    const isbnVal = document.querySelector(".meta-isbn");
    const publishdateVal = document.querySelector(".meta-publishdate");
    const publisherVal = document.querySelector(".meta-publisher");
    const seriesVal = document.querySelector(".meta-series");
    // const features_and_benefitsVal = document.querySelector( ".meta-features-and-benefits .value");
    const formatVal = document.querySelector(".meta-format");
    const languageVal = document.querySelector(".meta-language");
    const weightVal = document.querySelector(".meta-weight");
    const case_weightVal = document.querySelector(".meta-case-weight");
    const case_qtyVal = document.querySelector(".meta-case-qty");
    const physical_dimensionsVal = document.querySelector(".meta-physical_dimensions");
    const lengthVal = document.querySelector(".meta-length");
    const pointsizeVal = document.querySelector(".meta-pointsize");
    const priceVal = document.querySelector(".meta-price");
    //Contributor
    if (this.currentVariant.metafields.contributor && this.currentVariant.metafields.contributor != '[object Object]') {
      contributorVal.querySelector(".value").innerText = this.currentVariant.metafields.contributor;
      contributorVal.classList.remove("hide");
    } else {
      contributorVal.classList.add("hide");
      contributorVal.querySelector(".value").innerText = "";
    }
    //Narrator
    if (this.currentVariant.metafields.narrators && this.currentVariant.metafields.narrators != '[object Object]') {
      narratorsVal.querySelector(".value").innerText = this.currentVariant.metafields.narrators;
      narratorsVal.classList.remove("hide");
    } else {
      narratorsVal.classList.add("hide");
      narratorsVal.querySelector(".value").innerText = "";
    }
    //Contributor Bio
    if (this.currentVariant.metafields.contributor_bio_short) {
      contributorBioVal.querySelector(".value").innerHTML = this.currentVariant.metafields.contributor_bio_short;
      contributorBioVal.classList.remove("hide");
    } else {
      contributorBioVal.classList.add("hide");
      contributorBioVal.querySelector(".value").innerHTML = "";
    }
    //ISBN
    if (this.currentVariant.sku) {
      isbnVal.querySelector(".value").innerText = this.currentVariant.sku;
      isbnVal.querySelector(".label").innerText = "ISBN-13";
      isbnVal.classList.remove("hide");
    } else if (this.currentVariant.metafields.isbn10) {
      isbnVal.querySelector(".value").innerText = this.currentVariant.metafields.isbn10;
      isbnVal.querySelector(".label").innerText = "ISBN-10";
      isbnVal.classList.remove("hide");
    } else {
      isbnVal.classList.add("hide");
      isbnVal.querySelector(".value").innerText = "";
    }
    //Publish Date
    if (this.currentVariant.metafields.publish_date) {
      publishdateVal.querySelector(".value").innerText = this.currentVariant.metafields.publish_date;
      publishdateVal.classList.remove("hide");
    } else {
      publishdateVal.classList.add("hide");
      publishdateVal.querySelector(".value").innerText = "";
    }
    //Publisher
    if (this.currentVariant.metafields.publisher) {
      publisherVal.querySelector(".value").innerText = this.currentVariant.metafields.publisher;
      publisherVal.classList.remove("hide");
    } else {
      publisherVal.classList.add("hide");
      publisherVal.querySelector(".value").innerText = "";
    }
    //Series
    if (this.currentVariant.metafields.series) {
      seriesVal.querySelector(".value").innerText = this.currentVariant.metafields.series;
      seriesVal.classList.remove("hide");
    } else {
      seriesVal.classList.add("hide");
      seriesVal.querySelector(".value").innerText = "";
    }
    //Format
    if (this.currentVariant.metafields.format && this.currentVariant.metafields.format != '[object Object]') {
      formatVal.querySelector(".value").innerText = this.currentVariant.metafields.format;
      formatVal.classList.remove("hide");
    } else {
      formatVal.classList.add("hide");
      formatVal.querySelector(".value").innerText = "";
    }
    //Language
    if (this.currentVariant.metafields.language) {
      languageVal.querySelector(".value").innerText = this.currentVariant.metafields.language;
      languageVal.classList.remove("hide");
    } else {
      languageVal.classList.add("hide");
      languageVal.querySelector(".value").innerText = "";
    }
    //Weight
    if (typeof window.newBundleData !== 'undefined') {
      if (
        this.currentVariant.requires_shipping && this.currentVariant.weight &&
        window.newBundleData[this.currentVariant.id]["bundleWeight"] == ""
      ) {
        weightVal.querySelector(".value").innerText = this.currentVariant.weight;
        weightVal.classList.remove("hide");
      } else if (
        this.currentVariant.requires_shipping && window.newBundleData[this.currentVariant.id]["bundleWeight"]
      ) {
        weightVal.querySelector(".value").innerText = window.newBundleData[this.currentVariant.id]["bundleWeight"];
        weightVal.classList.remove("hide");
      } else {
        weightVal.classList.add("hide");
        weightVal.querySelector(".value").innerText = "";
      }
    }
    //Case Weight
    if (this.currentVariant.requires_shipping && this.currentVariant.metafields.case_weight) {
      case_weightVal.querySelector(".value").innerText = this.currentVariant.metafields.case_weight;
      case_weightVal.classList.remove("hide");
    } else {
      case_weightVal.classList.add("hide");
      case_weightVal.querySelector(".value").innerText = '';
    }
    //Case Qty
    if (this.currentVariant.requires_shipping && this.currentVariant.metafields.case_qty) {
      case_qtyVal.querySelector(".value").innerText = this.currentVariant.metafields.case_qty;
      case_qtyVal.classList.remove("hide");
    } else {
      case_qtyVal.classList.add("hide");
      case_qtyVal.querySelector(".value").innerText = '';
    }
    //Dimensions
    if (this.currentVariant.requires_shipping && this.currentVariant.metafields.physical_length && this.currentVariant.metafields.physical_width && this.currentVariant.metafields.physical_thickness) {
      physical_dimensionsVal.querySelector(".value").innerText = this.currentVariant.metafields.physical_length + '(h) x ' + this.currentVariant.metafields.physical_width + '(w) x ' + this.currentVariant.metafields.physical_thickness + '(d) inches';
      physical_dimensionsVal.classList.remove("hide");
    } else {
      physical_dimensionsVal.classList.add("hide");
      physical_dimensionsVal.querySelector(".value").innerText = "";
    }

    //Length aka Pages or Running Time
    if (this.currentVariant.metafields.lengthunit && this.currentVariant.metafields.length) {
      lengthVal.querySelector(".value").innerText = this.currentVariant.metafields.length;
      lengthVal.querySelector(".label").innerText = this.currentVariant.metafields.lengthunit;
    } else {
      lengthVal.classList.add("hide");
      lengthVal.querySelector(".value").innerText = "";
    }

    //Point Size
    if (this.currentVariant.metafields.pointsize) {
      pointsizeVal.querySelector(".value").innerText = this.currentVariant.metafields.pointsize + ' pt';
      pointsizeVal.classList.remove("hide");
    } else {
      pointsizeVal.classList.add("hide");
      pointsizeVal.querySelector(".value").innerText = "";
    }

    //Price
    if (this.currentVariant.price) {
      priceVal.querySelector(".value").innerText = numeral(this.currentVariant.price / 100).format(
        "$0,0.00");
      priceVal.classList.remove("hide");
    } else {
      priceVal.classList.add("hide");
      priceVal.querySelector(".value").innerText = "";
    }
    const allMetas = document.querySelectorAll(".meta-data");
    allMetas.forEach(meta => {
      var metaVal = meta.querySelector(".value").innerText;
      if (metaVal === '0' || metaVal.includes('[object Object]')) {
        meta.classList.add("hide");
        meta.querySelector(".value").innerText = "";
      }
    })
  },

  updateFormStatus() {
    const quantitySelector = document.querySelector("[data-quantity-selector]");

    if (quantitySelector) {
      const quantitySelectorInput = quantitySelector.querySelector("input[name=quantity]");
      let isVariantAvailable = this.currentVariant.available;

      if (window.newBundleData[this.currentVariant.id]['isBundle'] == 'true') {
        isVariantAvailable = window.newBundleData[this.currentVariant.id]["bundleMaxQuantity"] > 0;
      }

      if (
        this.currentVariant.requires_shipping &&
        isVariantAvailable
      ) {
        quantitySelector.classList.remove("deactivated");

        if (window.newBundleData[this.currentVariant.id]['isBundle'] == 'true' && window.newBundleData[this.currentVariant.id]["bundleMaxQuantity"] == 1) {
          quantitySelector.querySelector('[data-increase-quantity]').disabled = true
        }
      } else {
        quantitySelector.classList.add("deactivated");
        if (quantitySelectorInput) quantitySelectorInput.value = 1;
      }

      if (window.newBundleData[this.currentVariant.id]['isBundle'] == 'true') {
        if (window.newBundleData[this.currentVariant.id]["bundleMaxQuantity"] < 1) {
          this.disableAtc(true, "Sold Out", true);
        } else {
          this.disableAtc(false, "Add to cart");

          quantitySelectorInput.setAttribute('max', window.newBundleData[this.currentVariant.id]["bundleMaxQuantity"]);
        }
      } else {
        if (this.currentVariant.metafields.publish_date) {
          const today = dayjs();
          const publishDate = dayjs(this.currentVariant.metafields.publish_date);
          const ninetyDayDate = publishDate.subtract("91", "days");

          if (this.currentVariant.available) {
            if (
              today.isBefore(ninetyDayDate) &&
              this.currentVariant.requires_shipping
            ) {
              this.disableAtc(
                true,
                `Pre-Order: ${ninetyDayDate.format("MM/DD/YYYY")}`,
                true
              );
            } else if (
              today.isBefore(publishDate) &&
              !this.currentVariant.requires_shipping
            ) {
              this.disableAtc(
                true,
                `Available on ${publishDate.format("MM/DD/YYYY")}`,
                true
              );

            } else if (
              today.isAfter(ninetyDayDate) &&
              today.isBefore(publishDate) &&
              this.currentVariant.requires_shipping
            ) {
              this.disableAtc(false, "Pre-Order", true);
            } else {
              this.disableAtc(false, "Add to cart", true);
            }
          } else {
            if (
              today.isBefore(ninetyDayDate) &&
              this.currentVariant.requires_shipping
            ) {
              this.disableAtc(
                true,
                `Pre-Order: ${ninetyDayDate.format("MM/DD/YYYY")}`,
                true
              );
            } else if (
              today.isBefore(publishDate) &&
              !this.currentVariant.requires_shipping
            ) {
              this.disableAtc(
                true,
                `Available on ${publishDate.format("MM/DD/YYYY")}`,
                true
              );
            } else {
              this.disableAtc(true, "Sold Out");
            }
          }
        } else {
          if (!this.currentVariant.available) {
            this.disableAtc(true, "Sold Out");
          } else {
            this.disableAtc(false, "Add to cart");
          }
        }
      }
    }
  },

  setFirstLoadVariant() {
    // Get Selected or First Available Variant
    const variantId = document.getElementById('productTemplate').dataset.initialVariant
    const variant = this.product.variants.find(variant => variant.id == variantId)

    variant.options.forEach((option, index) => {
      this.currentOptions[Object.keys(this.currentOptions)[index]] = option
    })

    // Select inital DOM elements
    Object.keys(this.currentOptions).forEach(key => {
      this.selectOption(key, this.currentOptions[key], variant)
    });
  },

  openHowTo(event) {
    event.preventDefault()
    // Get Details
    const digitalDetails = document.getElementById('digitalDetails')
    if (!digitalDetails) return

    const content = document.createElement('div')
    content.innerHTML = digitalDetails.innerHTML
    // Replace with active type
    content.querySelector('.digitalDetailsType').innerText = this.currentVariant.metafields.digital
    // Show current type, hide the rest
    content.querySelectorAll('[data-type]').forEach(details => {
      if (details.dataset.type === this.currentVariant.metafields.digital.replaceAll(' ', '').replaceAll('-', '').toLowerCase()) {
        details.classList.remove('hidden')
      } else {
        details.classList.add('hidden')
      }
    })
    modal.open(content)
  },

  toggleContent(event) {
    const currentEl = event.target
    const parent = currentEl.closest('div')
    const container = parent.parentNode
    const nextEl = container.querySelector('div.hidden')
    parent.classList.add('hidden')
    nextEl.classList.remove('hidden')
  },

  toggleBundleItems() {
    const bundleSummary = document.getElementById('productBundleSummary');
    const bundleSlider = document.getElementById('productBundleSlider');

    if (bundleSummary && typeof window.newBundleData !== 'undefined') {
      if (window.newBundleData[this.currentVariant.id]['isBundle'] == 'true') {
        bundleSummary.innerHTML = window.newBundleData[this.currentVariant.id]["bundleItemSummary"];
        bundleSummary.classList.remove('hidden');
        bundleSlider.innerHTML = window.newBundleData[this.currentVariant.id]["bundleItemSlider"];
        bundleSlider.classList.remove('hidden');

        if (window.newBundleData[this.currentVariant.id]['bundleVariantIDS'].split(',').length > 1) {
          new Swiper('#productBundleSlider .bundleItemSlider__container', {
            navigation: {
              nextEl: '.bundleItemSlider__nav--next',
              prevEl: '.bundleItemSlider__nav--prev'
            },
          });
        }
      } else {
        bundleSummary.innerHTML = "";
        bundleSummary.classList.add('hidden');
        bundleSlider.innerHTML = window.newBundleData[this.currentVariant.id]["bundleItemSlider"];
        bundleSlider.classList.add('hidden');
      }
    }
  },

  updatePriceSavings() {
    const priceSavings = document.querySelector(".price__savings");

    if (priceSavings && typeof window.newBundleData !== 'undefined') {
      if (window.newBundleData[this.currentVariant.id]['isBundle'] == 'true') {
        if (window.newBundleData[this.currentVariant.id]["discount"]) {
          priceSavings.innerHTML = "Save " + window.newBundleData[this.currentVariant.id]["discount"] + "%";
          priceSavings.closest('#product-price-container').classList.add('hasSavings')
        } else {
          priceSavings.innerHTML = "";
          priceSavings.closest('#product-price-container').classList.remove('hasSavings')
        }
      } else {
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          let savingPercentage = (this.currentVariant.compare_at_price - this.currentVariant.price) * 100 / this.currentVariant.compare_at_price;
          savingPercentage = Math.round(savingPercentage);
          priceSavings.innerHTML = "Save " + parseInt(savingPercentage) + "%";
          priceSavings.closest('#product-price-container').classList.add('hasSavings')
        } else {
          priceSavings.innerHTML = "";
          priceSavings.closest('#product-price-container').classList.remove('hasSavings')
        }
      }
    }
  },

  toggleBulkInfo() {
    const bulkDiscount = window.newBundleData[this.currentVariant.id]["bulkDiscount"];
    const bulkMessage = window.newBundleData[this.currentVariant.id]["bulkMessage"];
    const bulkTable = window.newBundleData[this.currentVariant.id]["bulkHtml"];
    const bulkAnchor = document.querySelector(".bulk-anchor");
    const bulkAccordion = document.getElementById("bulk-pricing");

    // Toggle message
    if (this.currentVariant.requires_shipping) {
      if (bulkDiscount === 'hasCaseLink') {
        if (bulkAnchor && bulkMessage) {
          bulkAnchor.innerHTML = bulkMessage;
          bulkAnchor.classList.remove("hidden");
        } else {
          bulkAnchor.classList.add("hidden");
        }
        if (bulkAccordion) {
          bulkAccordion.classList.add("hidden");
        }
      } else if (bulkDiscount !== 'false') {
        if (bulkAnchor) {
          bulkAnchor.classList.remove("hidden");

          if (bulkAccordion) {
            bulkAccordion.classList.remove("hidden");
            bulkAccordion.innerHTML = bulkTable;
          };
        }
      }
    } else {
      if (bulkAnchor) {
        bulkAnchor.classList.add("hidden");
      }
      if (bulkAccordion) {
        bulkAccordion.classList.add("hidden");
      }
    }
  },

  buildReadSampleUrl() {
    const ebookVariant = this.getEbookVariant();

    if (ebookVariant == null) {
      return;
    }

    const hasEbookOption = ebookVariant.metafields.digital == 'eBook' || this.product.type == 'eBook';
    const digitalPublishDate = dayjs(ebookVariant.metafields.publish_date);
    const today = dayjs();
    const productIsbn = ebookVariant.isbn13 || ebookVariant.barcode;

    if (hasEbookOption == true && !today.isBefore(digitalPublishDate) && typeof productIsbn !== 'undefined') {
      const link = document.createElement('a');
      const linkHref = `https://preview.aer.io/${productIsbn}?social=1&retail=0&emailcap=0`
      const $linkContainer = document.querySelector('[data-ebook-link-container');

      // Build link structure
      link.href = linkHref;
      link.target = '_blank';
      link.text = 'Read a Sample';
      link.classList.add('button-text');
      if ($linkContainer) {
        $linkContainer.querySelector('[data-ebook-link-inner]').appendChild(link);
        $linkContainer.classList.remove('hidden');
      }
    }
  },

  getEbookVariant() {
    let ebookVariant = null;

    this.product.variants.forEach((variant, index) => {
      if (variant.metafields.digital == 'eBook') {
        ebookVariant = variant;
      }
    })

    return ebookVariant;
  },

  init() {
    // Get current product handle so that we can fetch product JSON
    this.productHandle = document.getElementById('productTemplate').dataset.productHandle

    // Fetch product JSON and assign it to the product property
    axios.get(`/products/${this.productHandle}?view=json`).then(res => {
      this.product = res.data
    }).then(() => {
      if (this.product.variants.length === 1) {
        this.currentVariant = this.product.variants[0]
      }

      // Create an empty object for option choices
      this.currentOptions = this.product.options.reduce((accumulator, currentOption) => ({ ...accumulator, [currentOption]: '' }), {})
      this.setFirstLoadVariant()
      this.buildReadSampleUrl()

    }).catch(error => {
      console.log(error)
      console.log('Error fetching product!')
    })

    // Connect Listener to Digital Link
    const digitalLink = document.getElementById('productDigitalMessageLink')

    if (digitalLink) {
      digitalLink.addEventListener('click', (event) => {
        this.openHowTo(event)
      })
    }
  }
}

export default productBuyBox
